// src/pages/History/EarlyModern/MingQingDynastiesGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Early_Modern_Period_-_Ming_and_Qing_Dynasties_China.png';

function HistoryPageMingQingDynastiesGo() {
  return (
    <QuizPage
      title="History: Ming and Qing Dynasties"
      subTopic="Ming and Qing Dynasties (China)"
      backgroundImage={historyImage}
      returnPath="/History-Ming-Qing-Dynasties"
    />
  );
}

export default HistoryPageMingQingDynastiesGo;
